import { render } from "./AppShell.vue?vue&type=template&id=1274400d&scoped=true&ts=true"
import script from "./AppShell.vue?vue&type=script&lang=ts"
export * from "./AppShell.vue?vue&type=script&lang=ts"

import "./AppShell.vue?vue&type=style&index=0&id=1274400d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1274400d"]])

export default __exports__